import { AutocompleteProps } from 'types/autocomplete';
import Autocomplete from '../Autocomplete';
import { EmployeeType } from 'types/staff';

interface RolesAutocompleteProps extends Omit<AutocompleteProps, 'options'> {
    defaultValues?: string;
}

const RolesAutocomplete = ({ defaultValues, ...props }: RolesAutocompleteProps) => {
    const roles: EmployeeType[] = ['MANAGER', 'CLERK'];

    return (
        <Autocomplete
            options={roles}
            defaultValue={defaultValues || null}
            onChange={(_: any, role: EmployeeType, ...rest) => {
                const { onChange } = props;
                onChange && onChange(_, role, ...rest);
            }}
            getOptionLabel={(option) => option}
            {...props}
        />
    );
};

export default RolesAutocomplete;
